import { MARKETPLACE_URL, WORKFLOWS_URL } from './env';

// this variable is used by module federation to load remote Workflows App
window.workflowsUrl = WORKFLOWS_URL || '';
window.marketplaceUrl = MARKETPLACE_URL || '';
import('./entryPoint');
export {}; // to supress typescript error for isolated modules.
